import { Components, Theme } from '@mui/material'
import { ComponentOptions } from '../types'
import { MuiOSHButton } from './MuiOSHButton'

export const getOSHComponents = (options: ComponentOptions): Components<Theme> => {
  return {
    MuiButton: MuiOSHButton(options),
  }
}
